class Invoices {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getInvoices(invoiceReferences) {
    return this.apiClient.post('pro/invoices/download', {
      invoice_references: invoiceReferences
    }).then(response => response.data);
  }
}

export { Invoices };
//# sourceMappingURL=Invoices.js.map
